import React, { useState } from "react";
import Modal from "react-modal";
import { Helmet } from "react-helmet";
import '@fortawesome/fontawesome-free/css/all.min.css';


Modal.setAppElement("#root");

export const Iclchat = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [videoIsOpen, setVideoIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const videoId = 'https://iclvideos.s3.ap-south-1.amazonaws.com/chatbots/Support_ChatBot.mp4';

  return (
    <div id="iclchat" className="text-center">
      {props.isStandalone && (
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>ICL ChatBot - Custom AI Development & Client Support</title>

        <link rel="canonical" href="https://eximon.com/iclchat" />

        <meta charSet="utf-8" />
        <meta
          name="description"
          content="ICL ChatBot provides AI chatbot development and a client support ticket system for ICL Software customers, improving automation and customer service."
        />

        {/* Open Graph */}
        <meta property="og:title" content="ICL ChatBot - Custom AI Development & Client Support" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://eximon.com/iclchat" />
        <meta
          property="og:description"
          content="Explore ICL ChatBot for AI-powered chatbot development and client support ticketing, designed to enhance business communication and customer service."
        />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ICL ChatBot - Custom AI Development & Client Support" />
        <meta
          name="twitter:description"
          content="ICL ChatBot offers AI chatbot development and a support ticket system for ICL Software clients, improving automation and customer service."
        />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
      </Helmet>
)}
      <div className="container">
        <div className="section-title">
          <h1 className="display-4 text-primary">ICL ChatBot</h1>
          <h2 className="display-3 text-dark">AI Chatbot Development Services. Transform Your Business with Intelligent Chatbots</h2>
          <div className="btn-group">
            <button onClick={() => setModalIsOpen(true)} type="button" className="btn btn-custom btn-lg" >
              Try me
            </button>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={() => setModalIsOpen(false)}
              className="custom-modal"
              overlayClassName="custom-overlay"
            // style={{
            //   content: {
            //     position: 'absolute',
            //     top: 'auto',
            //     left: 'auto',
            //     right: '0px',
            //     bottom: '20px',
            //     width: '400px',
            //     height: '500px'
            //   }
            // }}
            >
              <div className="custom-modal-header">
                {isLoading && <div style={{ fontWeight: "bold" }}>Please wait loading ...</div>}
              </div>
              <div className="custom-modal-body">
                <iframe
                  title="ICL chatBot"
                  src="https://dtegnbzmkqshu.cloudfront.net"
                  allowFullScreen
                  style={{ width: '100%', height: '90%' }} onLoad={() => setLoading(false)}
                />
              </div>
              {!isLoading &&
                <button style={{ marginTop: "5px" }} onClick={() => setModalIsOpen(false)} type="button" className="btn btn-custom btn-lg" >
                  Close
                </button>
              }
            </Modal>
            <button onClick={() => setVideoIsOpen(true)} type="button" className="btn btn-custom btn-lg" >
              Demo
            </button>
            <Modal
              isOpen={videoIsOpen}
              onRequestClose={() => setVideoIsOpen(false)}
              className="custom-modal"
              overlayClassName="custom-overlay"
            // style={{
            //   content: {
            //     position: 'absolute',
            //     top: 'auto',
            //     left: '10px',
            //     right: 'auto',
            //     bottom: '20px',
            //     width: '70%',
            //     height: '60%'
            //   }
            // }}
            >
              <div className="custom-modal-header">
                {isLoading && <div style={{ fontWeight: "bold" }}>Please wait loading ...</div>}
              </div>
              <div className="custom-modal-body">
                <iframe
                  title="ICL ChatBot Demo"
                  src={videoId}
                  allowFullScreen
                  style={{ width: '100%', height: '90%' }} onLoad={() => setLoading(false)}
                />
              </div>
              {!isLoading &&
                <button onClick={() => { setVideoIsOpen(false); setLoading(true); }} type="button" className="btn btn-custom btn-lg" >
                  Close
                </button>
              }
            </Modal>
            <a href="#contact" class="btn btn-custom btn-lg">Sign up</a>
          </div>
        </div>
        <div className="row mt-2" >
          {
            props.data
              ? props.data.map((d, i) => (
                <div key={`${d.Title}-${i}`} className="col-md-4 mb-3" >
                  <div className="fs-4 fw-bold text-white bg-primary p-2 rounded-3">
                    <i className="fas fa-rocket me-2" style={{ marginRight: '10px' }}></i>
                    {d.Title && d.Title}
                  </div>
                  <div className="fs-5 fw-semibold text-white bg-primary p-2 rounded-3" style={{ marginTop: '10px' }}>
                    <i className="fas fa-lightbulb me-3" style={{ marginRight: '10px' }} ></i>
                    {d.Subtitle && d.Subtitle}
                  </div>
                  <div className="fs-5 p-2 fw-bold rounded shadow-sm text-center" style={{
                    margin: '10px',
                    backgroundColor: (d.Subtitle === "Expertise:" || d.Subtitle === "Transform Your Business:" || d.Title === "Chatbot Use Cases:" || d.Title === "Our Services") ? 'rgba(9, 68, 91, 0.46)' : 'rgba(135, 207, 235, 0.16)',
                    color: (d.Subtitle === "Expertise:" || d.Subtitle === "Transform Your Business:" || d.Title === "Chatbot Use Cases:" || d.Title === "Our Services") ? '#fff' : '#1a1a1a',
                    border: '1px solid #ccc',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                  }}>
                    {d.Paragraph}
                  </div>

                </div>
              ))
              : "loading"}
        </div>
      </div>
    </div>

  );
};
